/**
 * Alt a11y text, which gets displayed in case emoji loading fails
 */
export const emojiAltMapping = {
  "🥳": $localize`Partygesicht`,
  "👀": $localize`Augenpaar`,
  "🤓": $localize`Brillenträger`,
  "🩺": $localize`Stethoskop`,
  "🏃": $localize`Laufende Person`,
  "🏃‍♂️": $localize`Laufender Mann`,
  "🏃‍♀️": $localize`Laufende Frau`,
  "🚬": $localize`Zigarette`,
  "👋": $localize`Winkende Hand`,
  "💰": $localize`Geldsack`,
  "🧑": $localize`Erwachsener`,
  "👨": $localize`Mann`,
  "👩‍🦰": $localize`Frau`,
  "😌": $localize`Entspanntes Gesicht`,
  "⏳": $localize`Sanduhr`,
  "🎂": $localize`Geburtstagskuchen`,
  "📫": $localize`Briefkasten`,
  "💪": $localize`Bizeps`,
  "❤️": $localize`Rotes Herz`,
  "🙋": $localize`Hand heben`,
  "🤩": $localize`Begeistertes Gesicht`,
  "🚜": $localize`Traktor`,
  "🥷": $localize`Ninja`,
  "🧑‍💻": $localize`IT-Fachkraft`,
  "👮": $localize`Polizeibeamte:r`,
  "🧑‍⚕️": $localize`Mediziner:in`,
  "🧑‍🔬": $localize`Wissenschaftler:in`,
  "🚗": $localize`Auto`,
  "🧑‍🏫": $localize`Lehrperson`,
  "🐕": $localize`Hund`,
  "🧑‍🚒": $localize`Feuerwehrfrau oder Feuerwehrmann`,
  "🧑‍🍳": $localize`Köchin oder Koch`,
  "🧙": $localize`Magier:in`,
  "🕵️": $localize`Detektiv:in`,
  "🧑‍💼": $localize`Büroangestellte:r`,
  "🦸": $localize`Superheld:in`,
  "🔍": $localize`Lupe`,
  "😵": $localize`Verwirrtes Gesicht`,
  "💼": $localize`Aktentasche`,
  "✅": $localize`Häkchen`,
  "📈": $localize`Wachsende Grafik`,
  "🎢": $localize`Achterbahn`,
  "💌": $localize`Brief mit Herz`,
  "💚": $localize`Grünes Herz`,
  "🤝": $localize`Hände schütteln`,
};

export type Emoji = keyof typeof emojiAltMapping;
